(function () {
  const SET_MAP = { OGN: 0, OGS: 1, ARC: 2, SFD: 3, UNL: 4, VEN: 5, RAD: 6 };
  const VARIANT_MAP = { "": 0, a: 1, s: 2, "*": 2, b: 3 };
  const FORMAT = 1;
  const VERSION = 5;
  const BASE32 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
  const SET_ORDER = Object.keys(SET_MAP);
  const DOMAINS = ["fury", "calm", "mind", "body", "chaos", "order"];

  function base32Encode(bytes) {
    let out = "";
    let buffer = 0;
    let bits = 0;
    for (const b of bytes) {
      buffer = ((buffer << 8) | b) & 0xffff;
      bits += 8;
      while (bits >= 5) {
        bits -= 5;
        out += BASE32[(buffer >> bits) & 0x1f];
      }
    }
    if (bits > 0) out += BASE32[(buffer << (5 - bits)) & 0x1f];
    return out;
  }

  function base32Decode(str) {
    const bytes = [];
    let buffer = 0;
    let bits = 0;
    for (const ch of str) {
      const v = BASE32.indexOf(ch.toUpperCase());
      if (v < 0) throw new Error("Invalid character in deck code: '" + ch + "'");
      buffer = ((buffer << 5) | v) & 0xffff;
      bits += 5;
      while (bits >= 8) {
        bits -= 8;
        bytes.push((buffer >> bits) & 0xff);
      }
    }
    return bytes;
  }

  function varint(value) {
    if (value === 0) return [0];
    const out = [];
    while (value !== 0) {
      let b = value & 0x7f;
      value >>>= 7;
      if (value !== 0) b |= 0x80;
      out.push(b);
    }
    return out;
  }

  function Reader(bytes) {
    this.bytes = bytes;
    this.pos = 0;
  }
  Reader.prototype.byte = function () {
    if (this.pos >= this.bytes.length) throw new Error("Deck code ended early");
    return this.bytes[this.pos++];
  };
  Reader.prototype.varint = function () {
    let result = 0;
    let shift = 0;
    while (this.pos < this.bytes.length) {
      const b = this.bytes[this.pos++];
      result |= (b & 0x7f) << shift;
      if ((b & 0x80) !== 0x80) return result;
      shift += 7;
    }
    throw new Error("Byte array did not contain valid varints.");
  };

  function parseCardCode(code) {
    const parts = String(code).split("-");
    if (parts.length !== 2 || !parts[0] || !parts[1]) throw new Error("Invalid card code format: " + code);
    const m = parts[1].match(/^((?:R|SP)?\d+)([a-z*]?)$/);
    if (!m) throw new Error("Invalid card code format: " + code);
    return { set: parts[0], number: m[1], variant: m[2] || "" };
  }

  function numberFlag(number) {
    if (number.indexOf("SP") === 0) return { flag: 0x02, value: parseInt(number.slice(2), 10) };
    if (number.charAt(0) === "R") return { flag: 0x01, value: parseInt(number.slice(1), 10) };
    return { flag: 0x00, value: parseInt(number, 10) };
  }

  function numberFromFlag(flag, num) {
    if (flag === 0x02) return "SP" + num;
    if (flag === 0x01) return "R" + String(num).padStart(2, "0");
    if (flag === 0x00) return String(num).padStart(3, "0");
    throw new Error("Unknown number-prefix flag: " + flag);
  }

  function keyOfValue(map, value) {
    for (const k in map) if (map[k] === value) return k;
    return undefined;
  }

  function groupBySetAndVariant(cards) {
    const groups = {};
    for (const card of cards) {
      const p = parseCardCode(card.cardCode);
      const key = p.set + "-" + p.variant;
      if (!groups[key]) {
        if (SET_MAP[p.set] === undefined) throw new Error("Unknown set: " + p.set);
        if (VARIANT_MAP[p.variant] === undefined) throw new Error("Unknown variant: '" + p.variant + "'");
        groups[key] = { set: SET_MAP[p.set], variant: VARIANT_MAP[p.variant], cardNumbers: [] };
      }
      groups[key].cardNumbers.push(p.number);
    }
    return Object.keys(groups).map(function (k) { return groups[k]; })
      .sort(function (a, b) { return a.set !== b.set ? a.set - b.set : a.variant - b.variant; })
      .map(function (g) {
        g.cardNumbers.sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
        return g;
      });
  }

  function pushGroups(bytes, cards, writeNumber) {
    const groups = groupBySetAndVariant(cards);
    bytes.push.apply(bytes, varint(groups.length));
    for (const g of groups) {
      bytes.push.apply(bytes, varint(g.cardNumbers.length));
      bytes.push(g.set, g.variant);
      for (const n of g.cardNumbers) writeNumber(bytes, n);
    }
  }

  function writeFlagged(bytes, number) {
    const nf = numberFlag(number);
    bytes.push(nf.flag);
    bytes.push.apply(bytes, varint(nf.value));
  }

  function writeBare(bytes, number) {
    bytes.push.apply(bytes, varint(parseInt(number, 10)));
  }

  function encodeSection(deck, maxCount, version) {
    const bytes = [];
    for (let count = maxCount; count >= 1; count--) {
      pushGroups(bytes, deck.filter(function (c) { return c.count === count; }), version >= 4 ? writeFlagged : writeBare);
    }
    return bytes;
  }

  function encodeSectionSparse(deck, flagged) {
    const bytes = [];
    const counts = [];
    for (const c of deck) if (c.count >= 1 && counts.indexOf(c.count) < 0) counts.push(c.count);
    counts.sort(function (a, b) { return b - a; });
    bytes.push.apply(bytes, varint(counts.length));
    for (const count of counts) {
      bytes.push.apply(bytes, varint(count));
      pushGroups(bytes, deck.filter(function (c) { return c.count === count; }), flagged ? writeFlagged : writeBare);
    }
    return bytes;
  }

  function readGroups(r, count, flagged, signedSuffix, out) {
    const numGroups = r.varint();
    for (let i = 0; i < numGroups; i++) {
      const numCards = r.varint();
      const set = r.byte();
      const variant = r.byte();
      const setCode = keyOfValue(SET_MAP, set);
      if (!setCode) throw new Error("Unknown set code: " + set);
      const variantCode = variant === 2 ? signedSuffix : keyOfValue(VARIANT_MAP, variant);
      for (let j = 0; j < numCards; j++) {
        const flag = flagged ? r.byte() : 0x00;
        const num = r.varint();
        out.push({ cardCode: setCode + "-" + numberFromFlag(flag, num) + (variantCode || ""), count: count });
      }
    }
  }

  function decodeSection(r, maxCount, signedSuffix, version) {
    const deck = [];
    for (let count = maxCount; count >= 1; count--) readGroups(r, count, version >= 4, signedSuffix, deck);
    return deck;
  }

  function decodeSectionSparse(r, signedSuffix, flagged) {
    const deck = [];
    const numCounts = r.varint();
    for (let i = 0; i < numCounts; i++) {
      const count = r.varint();
      readGroups(r, count, flagged, signedSuffix, deck);
    }
    return deck;
  }

  function encodeCards(mainDeck, sideboard, chosenChampion) {
    sideboard = sideboard || [];
    for (const card of mainDeck.concat(sideboard)) {
      if (!Number.isSafeInteger(card.count) || card.count < 1) {
        throw new Error("Invalid card count for " + card.cardCode + ": " + card.count);
      }
    }
    const all = mainDeck.concat(sideboard).map(function (c) { return c.cardCode; });
    if (chosenChampion) all.push(chosenChampion);
    const prefixes = all.map(function (code) { return parseCardCode(code).number; });
    const needsV4 = prefixes.some(function (n) { return n.charAt(0) === "R"; });
    const anySpecial = prefixes.some(function (n) { return n.indexOf("SP") === 0; });
    let maxMain = 0;
    let maxSide = 0;
    for (const c of mainDeck) maxMain = Math.max(maxMain, c.count);
    for (const c of sideboard) maxSide = Math.max(maxSide, c.count);
    const needsV5 = maxMain > 12 || maxSide > 3;
    const version = needsV5 || anySpecial ? 5 : needsV4 ? 4 : 3;
    const flagged = needsV4 || anySpecial;

    const bytes = [(FORMAT << 4) | version];
    if (version >= 5) {
      bytes.push(flagged ? 1 : 0);
      bytes.push.apply(bytes, encodeSectionSparse(mainDeck, flagged));
      bytes.push.apply(bytes, encodeSectionSparse(sideboard, flagged));
    } else {
      bytes.push.apply(bytes, encodeSection(mainDeck, 12, version));
      bytes.push.apply(bytes, encodeSection(sideboard, 3, version));
    }
    if (chosenChampion) {
      const p = parseCardCode(chosenChampion);
      if (SET_MAP[p.set] === undefined) throw new Error("Unknown set in chosen champion: " + p.set);
      if (VARIANT_MAP[p.variant] === undefined) throw new Error("Unknown variant in chosen champion: '" + p.variant + "'");
      bytes.push(0x01, SET_MAP[p.set], VARIANT_MAP[p.variant]);
      if (flagged) writeFlagged(bytes, p.number);
      else writeBare(bytes, p.number);
    } else {
      bytes.push(0x00);
    }
    return base32Encode(bytes);
  }

  function decodeCards(code, options) {
    const signedSuffix = (options && options.signedSuffix) || "s";
    const r = new Reader(base32Decode(String(code).trim()));
    const fv = r.byte();
    const format = (fv >> 4) & 0x0f;
    const version = fv & 0x0f;
    if (format !== FORMAT) throw new Error("Unsupported format: " + format);
    if (version > VERSION) throw new Error("Unsupported version: " + version + " (max " + VERSION + ")");
    let flagged;
    if (version >= 5) {
      const bit = r.byte();
      if (bit > 1) throw new Error("Unsupported deck prefix flag: " + bit);
      flagged = bit === 1;
    } else {
      flagged = version >= 4;
    }
    let mainDeck;
    let sideboard = [];
    if (version >= 5) {
      mainDeck = decodeSectionSparse(r, signedSuffix, flagged);
      sideboard = decodeSectionSparse(r, signedSuffix, flagged);
    } else {
      mainDeck = decodeSection(r, 12, signedSuffix, version);
      if (version >= 2) sideboard = decodeSection(r, 3, signedSuffix, version);
    }
    let chosenChampion;
    if (version >= 3 && r.byte() === 0x01) {
      const set = r.byte();
      const variant = r.byte();
      const flag = flagged ? r.byte() : 0x00;
      const num = r.varint();
      const setCode = keyOfValue(SET_MAP, set);
      if (!setCode) throw new Error("Unknown set code in champion: " + set);
      const variantCode = variant === 2 ? signedSuffix : keyOfValue(VARIANT_MAP, variant);
      chosenChampion = setCode + "-" + numberFromFlag(flag, num) + (variantCode || "");
    }
    return { mainDeck: mainDeck, sideboard: sideboard, chosenChampion: chosenChampion, version: version };
  }

  let index = null;

  function db() { return window.CARD_DB || []; }

  function types(c) { return c.types || []; }

  function isRune(c) { return types(c).indexOf("rune") >= 0; }
  function isLegend(c) { return types(c).indexOf("legend") >= 0; }
  function isBattlefield(c) { return types(c).indexOf("battlefield") >= 0; }
  function isChampionUnit(c) { return window.RB.Decklists.isChampionUnit(c); }
  function isToken(c) { return !!c.token || (c.supertypes || []).indexOf("token") >= 0 || /^[a-z]{3}-t\d+$/.test(c.id); }

  function printingRank(c) {
    const s = SET_ORDER.indexOf(c.set);
    return (s < 0 ? 99 : s) * 100000 + (c.collector_number || 0) + (c.id.indexOf("-star-") > 0 ? 50000 : 0);
  }

  function earlier(a, b) { return !b || printingRank(a) < printingRank(b); }

  function codeOf(card) {
    const m = String(card.public_code || "").match(/^([A-Z]{3})-((?:R|SP|T)?\d+)([a-z*]?)(?:\/\d+)?$/);
    if (m) return m[1] + "-" + m[2] + m[3];
    const p = String(card.id).split("-");
    return p[0].toUpperCase() + "-" + p[1].toUpperCase();
  }

  function norm(s) {
    return String(s).toLowerCase().replace(/[’‘]/g, "'").replace(/\s+/g, " ").trim();
  }

  function buildIndex() {
    index = { byCode: {}, byName: {}, byNameSet: {}, byId: {}, runeOf: {}, legends: [] };
    for (const c of db()) {
      if (isToken(c) && !isRune(c)) continue;
      index.byId[c.id] = c;
      const code = codeOf(c);
      if (!index.byCode[code] || earlier(c, index.byCode[code])) index.byCode[code] = c;
      const base = code.replace(/[a-z*]$/, "");
      if (!index.byCode[base] || earlier(c, index.byCode[base])) index.byCode[base] = c;
      const n = norm(c.name);
      if (!index.byName[n] || earlier(c, index.byName[n])) index.byName[n] = c;
      const ns = n + "|" + c.set;
      if (!index.byNameSet[ns] || earlier(c, index.byNameSet[ns])) index.byNameSet[ns] = c;
      if (isRune(c)) {
        const dom = (c.domains || [])[0];
        if (dom && (!index.runeOf[dom] || earlier(c, index.runeOf[dom]))) index.runeOf[dom] = c;
      }
      if (isLegend(c)) index.legends.push(c);
    }
    return index;
  }

  function idx() { return index || buildIndex(); }

  function findByCode(code) {
    const m = String(code).trim().toUpperCase().match(/^([A-Z]{3})-((?:R|SP|T)?\d+)([A-Z*]?)(?:\/\d+)?$/);
    if (!m) return null;
    const ix = idx();
    const num = m[2].charAt(0) === "R" ? "R" + m[2].slice(1) : m[2].indexOf("SP") === 0 ? "SP" + m[2].slice(2) : m[2];
    const key = m[1] + "-" + num;
    return ix.byCode[key + m[3].toLowerCase()] || ix.byCode[key] || null;
  }

  function findByName(name, set) {
    const ix = idx();
    const n = norm(name);
    if (set) {
      const hit = ix.byNameSet[n + "|" + String(set).toUpperCase()];
      if (hit) return hit;
    }
    return ix.byName[n] || null;
  }

  function findLegend(name) {
    const ix = idx();
    const n = norm(name);
    const legends = ix.legends.slice().sort(function (a, b) { return printingRank(a) - printingRank(b); });
    const nameOf = function (c) { return norm(c.name).replace(/\s*-\s*starter$/, ""); };
    for (const c of legends) if (norm(c.name) === n || nameOf(c) === n) return c;
    const comma = n.indexOf(",");
    if (comma > 0) {
      const champ = n.slice(0, comma).trim();
      const title = n.slice(comma + 1).trim();
      for (const c of legends) {
        if (nameOf(c) === title && (c.tags || []).some(function (t) { return norm(t) === champ; })) return c;
      }
      for (const c of legends) if (nameOf(c) === title) return c;
    }
    for (const c of legends) if (nameOf(c).indexOf(n) === 0) return c;
    return null;
  }

  function runeDomainOf(card) { return isRune(card) ? (card.domains || [])[0] : null; }

  function runeCardOf(dom) { return idx().runeOf[dom] || null; }

  function displayName(card) {
    if (!card) return "";
    return isLegend(card) && (card.tags || []).length ? card.tags[card.tags.length - 1] + ", " + card.name.replace(/\s*-\s*Starter$/, "") : card.name;
  }

  const HEADER = /^(legends?|champions?|units?|spells?|gears?|runes?|battlefields?|main( deck)?|deck|mainboard|sideboard|side)\s*(\(\s*\d+\s*\))?\s*:?$/i;
  const CODE_TOKEN = /^([A-Za-z]{3}-(?:R|SP|T|r|sp|t)?\d+[a-z*]?(?:\/\d+)?)(?:\s+(.*))?$/;

  function splitCount(line) {
    let m = line.match(/^(\d+)\s*[x×]?\s+(.+)$/i);
    if (m) return { count: parseInt(m[1], 10), rest: m[2].trim() };
    m = line.match(/^(.+?)\s*[x×]\s*(\d+)$/i);
    if (m) return { count: parseInt(m[2], 10), rest: m[1].trim() };
    return { count: 1, rest: line.trim(), implicit: true };
  }

  function resolveLine(rest) {
    const codeM = rest.match(CODE_TOKEN);
    if (codeM) {
      const c = findByCode(codeM[1]);
      if (c) return c;
    }
    let name = rest;
    let set = null;
    let m = name.match(/^(.*?)\s*[\(\[]\s*([A-Za-z]{3})\s*[\)\]]$/);
    if (m) { name = m[1]; set = m[2]; }
    m = name.match(/^(.*?)\s*[\(\[]\s*([A-Za-z]{3}-(?:R|SP|T)?\d+[a-z*]?(?:\/\d+)?)\s*[\)\]]$/i);
    if (m) {
      const c = findByCode(m[2]);
      if (c) return c;
      name = m[1];
    }
    m = name.match(/^(.*?)\s*[\-–—]\s*([A-Za-z]{3})$/);
    if (m && SET_MAP[m[2].toUpperCase()] !== undefined) { name = m[1]; set = m[2]; }
    return findByName(name, set) || findLegend(name);
  }

  function looksLikeCode(text) {
    const t = text.trim();
    return t.length >= 8 && /^[A-Za-z2-7]+$/.test(t) && t.charAt(0).toUpperCase() === "C";
  }

  function emptyParse() {
    return { legend: null, champion: null, battlefields: [], runes: {}, deck: [], side: [], unknown: [], warnings: [] };
  }

  function place(out, card, count, section, inSide) {
    if (inSide) {
      for (let i = 0; i < count; i++) out.side.push(card.id);
      return;
    }
    const dom = runeDomainOf(card);
    if (dom) { out.runes[dom] = (out.runes[dom] || 0) + count; return; }
    if (isLegend(card)) {
      if (out.legend && out.legend !== card.id) out.warnings.push("second legend ignored: " + card.name);
      else out.legend = card.id;
      return;
    }
    if (isBattlefield(card)) {
      if (out.battlefields.indexOf(card.id) >= 0) out.warnings.push("battlefield listed twice: " + card.name);
      else out.battlefields.push(card.id);
      if (count > 1) out.warnings.push("battlefield count ignored: " + card.name);
      return;
    }
    if (section === "champion") {
      if (!out.champion) out.champion = card.id;
      else if (out.champion !== card.id) out.warnings.push("second champion ignored: " + card.name);
      if (!isChampionUnit(card)) out.warnings.push(card.name + " is not a champion unit");
      if (count.explicit) for (let i = 0; i < count.n; i++) out.deck.push(card.id);
      return;
    }
    for (let i = 0; i < count; i++) out.deck.push(card.id);
  }

  function sectionOf(header) {
    const h = header.toLowerCase();
    if (/^side/.test(h)) return "side";
    if (/^champion/.test(h)) return "champion";
    if (/^legend/.test(h)) return "legend";
    return "main";
  }

  function parseText(text) {
    const out = emptyParse();
    if (!text || !String(text).trim()) return out;
    if (looksLikeCode(text)) return parseCode(text.trim(), out);
    const lines = String(text).replace(/\r/g, "").split("\n");
    let section = "main";
    for (const raw of lines) {
      let line = raw.replace(/\s*(#|\/\/).*$/, "").trim();
      if (!line) continue;
      if (HEADER.test(line)) { section = sectionOf(line); continue; }
      const hm = line.match(/^(?:#+\s*|\*\*)?([A-Za-z ]+?)(?:\*\*)?\s*(?:\(\d+\))?\s*:$/);
      if (hm && HEADER.test(hm[1].trim())) { section = sectionOf(hm[1].trim()); continue; }
      if (looksLikeCode(line) && line.length >= 16) {
        const sub = parseCode(line, emptyParse());
        if (!sub.unknown.length || sub.deck.length) { merge(out, sub); continue; }
      }
      const sc = splitCount(line);
      const card = resolveLine(sc.rest);
      if (!card) { out.unknown.push(line); continue; }
      if (section === "champion") place(out, card, { n: sc.count, explicit: !sc.implicit }, "champion", false);
      else place(out, card, sc.count, section, section === "side");
    }
    return finish(out);
  }

  function merge(out, sub) {
    if (sub.legend && !out.legend) out.legend = sub.legend;
    if (sub.champion && !out.champion) out.champion = sub.champion;
    for (const b of sub.battlefields) if (out.battlefields.indexOf(b) < 0) out.battlefields.push(b);
    for (const d in sub.runes) out.runes[d] = (out.runes[d] || 0) + sub.runes[d];
    out.deck = out.deck.concat(sub.deck);
    out.side = out.side.concat(sub.side);
    out.unknown = out.unknown.concat(sub.unknown);
    out.warnings = out.warnings.concat(sub.warnings);
  }

  function parseCode(code, out) {
    let raw;
    try {
      raw = decodeCards(code);
    } catch (e) {
      out.unknown.push(code);
      out.warnings.push("deck code: " + e.message);
      return out;
    }
    for (const entry of raw.mainDeck) {
      const c = findByCode(entry.cardCode);
      if (!c) { out.unknown.push(entry.count + " " + entry.cardCode); continue; }
      place(out, c, entry.count, "main", false);
    }
    for (const entry of raw.sideboard) {
      const c = findByCode(entry.cardCode);
      if (!c) { out.unknown.push(entry.count + " " + entry.cardCode + " (side)"); continue; }
      place(out, c, entry.count, "side", true);
    }
    if (raw.chosenChampion) {
      const c = findByCode(raw.chosenChampion);
      if (c) out.champion = c.id;
      else out.unknown.push(raw.chosenChampion + " (champion)");
    }
    out.codeVersion = raw.version;
    return finish(out);
  }

  function finish(out) {
    if (!out.champion) {
      for (const id of out.deck) {
        const c = idx().byId[id];
        if (c && isChampionUnit(c)) { out.champion = id; break; }
      }
    }
    if (out.battlefields.length > 3) out.warnings.push("more than 3 battlefields listed; extra ones dropped");
    out.battlefields = out.battlefields.slice(0, 3);
    return out;
  }

  function toDeck(parsed, opts) {
    opts = opts || {};
    const deck = {
      id: opts.id || "custom-" + Date.now(),
      name: opts.name || defaultName(parsed),
      tagline: opts.tagline || "",
      legend: parsed.legend || null,
      champion: parsed.champion || null,
      battlefields: (parsed.battlefields || []).slice(0, 3),
      runes: {},
      deck: (parsed.deck || []).slice(),
      side: (parsed.side || []).slice(),
    };
    for (const d of DOMAINS) if (parsed.runes && parsed.runes[d]) deck.runes[d] = parsed.runes[d];
    const problems = [];
    if (deck.champion && deck.deck.indexOf(deck.champion) < 0) {
      deck.deck.push(deck.champion);
      problems.push("added one copy of the chosen champion to the main deck");
    }
    for (const u of parsed.unknown || []) problems.push("unknown: " + u);
    for (const w of parsed.warnings || []) problems.push(w);
    const valid = window.RB && window.RB.Decklists ? window.RB.Decklists.validate(deck) : [];
    return { deck: deck, problems: problems.concat(valid), valid: valid.length === 0 };
  }

  function defaultName(parsed) {
    const ix = idx();
    const l = parsed.legend ? ix.byId[parsed.legend] : null;
    const c = parsed.champion ? ix.byId[parsed.champion] : null;
    if (l && c) return displayName(l) + " — " + c.name.split(",")[0];
    if (l) return displayName(l);
    return "Imported deck";
  }

  function tally(ids) {
    const counts = {};
    const order = [];
    for (const id of ids) {
      if (!counts[id]) { counts[id] = 0; order.push(id); }
      counts[id]++;
    }
    return order.map(function (id) { return { id: id, count: counts[id] }; });
  }

  function lineFor(card, count, names) {
    return count + " " + codeOf(card) + (names ? " " + card.name : "");
  }

  function exportText(deck, opts) {
    opts = opts || {};
    const ix = idx();
    const names = !!opts.names;
    const lines = [];
    const card = function (id) { return ix.byId[id] || (window.RB && window.RB.Setup ? window.RB.Setup.findCard(id) : null); };
    if (deck.legend && card(deck.legend)) lines.push("LEGEND", lineFor(card(deck.legend), 1, names), "");
    if (deck.champion && card(deck.champion)) lines.push("CHAMPION", lineFor(card(deck.champion), 0, names).replace(/^0 /, ""), "");
    const fields = (deck.battlefields || []).filter(card);
    if (fields.length) {
      lines.push("BATTLEFIELD");
      for (const id of fields) lines.push(lineFor(card(id), 1, names));
      lines.push("");
    }
    const runes = [];
    for (const d of DOMAINS) if (deck.runes && deck.runes[d]) runes.push(d);
    if (runes.length) {
      lines.push("RUNE");
      for (const d of runes) lines.push(lineFor(runeCardOf(d), deck.runes[d], names));
      lines.push("");
    }
    lines.push("MAIN");
    const main = tally(deck.deck || []).filter(function (e) { return card(e.id); });
    main.sort(function (a, b) { return b.count - a.count || codeOf(card(a.id)).localeCompare(codeOf(card(b.id)), undefined, { numeric: true }); });
    for (const e of main) lines.push(lineFor(card(e.id), e.count, names));
    const side = tally(deck.side || []).filter(function (e) { return card(e.id); });
    if (side.length) {
      lines.push("", "SIDEBOARD");
      for (const e of side) lines.push(lineFor(card(e.id), e.count, names));
    }
    return lines.join("\n").replace(/\n+$/, "") + "\n";
  }

  function encodeCode(deck) {
    const ix = idx();
    const card = function (id) { return ix.byId[id] || (window.RB && window.RB.Setup ? window.RB.Setup.findCard(id) : null); };
    const main = [];
    for (const e of tally(deck.deck || [])) if (card(e.id)) main.push({ cardCode: codeOf(card(e.id)), count: e.count });
    for (const d of DOMAINS) {
      if (deck.runes && deck.runes[d] && runeCardOf(d)) main.push({ cardCode: codeOf(runeCardOf(d)), count: deck.runes[d] });
    }
    for (const id of deck.battlefields || []) if (card(id)) main.push({ cardCode: codeOf(card(id)), count: 1 });
    if (deck.legend && card(deck.legend)) main.push({ cardCode: codeOf(card(deck.legend)), count: 1 });
    const side = [];
    for (const e of tally(deck.side || [])) if (card(e.id)) side.push({ cardCode: codeOf(card(e.id)), count: e.count });
    const champion = deck.champion && card(deck.champion) ? codeOf(card(deck.champion)) : undefined;
    return encodeCards(main, side, champion);
  }

  function decodeCode(str) {
    return parseCode(String(str).trim(), emptyParse());
  }

  window.RB = window.RB || {};
  window.RB.DeckImport = {
    SET_MAP: SET_MAP,
    VARIANT_MAP: VARIANT_MAP,
    VERSION: VERSION,
    parseText: parseText,
    toDeck: toDeck,
    exportText: exportText,
    encodeCode: encodeCode,
    decodeCode: decodeCode,
    encodeCards: encodeCards,
    decodeCards: decodeCards,
    findByCode: findByCode,
    findByName: findByName,
    findLegend: findLegend,
    codeOf: codeOf,
    runeCardOf: runeCardOf,
    displayName: displayName,
    resetIndex: function () { index = null; },
  };
})();
